/* eslint-disable class-methods-use-this */
/* eslint-disable no-empty-function */
/* eslint-disable no-useless-constructor */
import $ from 'jquery';

class GdprPopup {
  constructor() {
    this.execute();
  }

  execute() {
    const acceptedCookies = document.cookie.indexOf('accepted_cookies=') >= 0;
    if (!acceptedCookies) {
      $('#acceptCookiesModal').addClass('show').removeClass('hide');
      setTimeout(function () {
        $('#acceptCookiesModal').addClass('hide').removeClass('show');
      }, 60000);
    }
    $('#btnAcceptCookies').on('click', function (e) {
      e.preventDefault();
      document.cookie = 'accepted_cookies=yes; path=/; max-age=31536000';
      $('#acceptCookiesModal').addClass('hide').removeClass('show');
    });

    $('#btnMoreOptions').on('click', function (e) {
      document.cookie = 'accepted_cookies=yes; path=/; max-age=31536000';
    });
  }
}

export default function initGdprPopup() {
  $(function () {
    new GdprPopup();
  });
}
